import './styles.scss'
import React from 'react'

import { usersHelpers } from 'utils'
import DisplayNameMsg from '../../DisplayNameMsg'
import ChatChannelWallMessagesPlugins from '../ChatChannelWallMessagesPlugins'

const ChatChannelWallActionDetail = ({ user, node, wallSettings, padding = 10, id, index, isShowComments, getCommentClassName }) => {
  return (
    <>
      <div className={`action-detail mt-1 ${node.type}`} style={{ paddingLeft: padding }}>
        <div className={'rounded comments ' + getCommentClassName(isShowComments, index, wallSettings)}>
          <DisplayNameMsg
            user={user}
            type={node.type.toLowerCase()}
            typeTitle={node.typeTitle}
            operatorName={node.postedBy && node.postedBy.name}
          />

          <div className='content'>
            <div
              dangerouslySetInnerHTML={{
                __html: usersHelpers.showLinkMessages(node.messageContent.messageText),
              }}
            />
          </div>

          <ChatChannelWallMessagesPlugins user={user} node={node} paddingType={wallSettings.paddingType} />

          {node.actionDetailList.map((node, indexComment) => (
            <div key={indexComment} id={id}>
              <ChatChannelWallActionDetail
                user={user}
                node={node}
                wallSettings={wallSettings}
                padding={padding}
                id={id}
                index={indexComment}
                isShowComments={isShowComments}
                getCommentClassName={getCommentClassName}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ChatChannelWallActionDetail
